import PropTypes from 'prop-types';
import React from 'react';

const LocationFilled = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="location"
  >
    <path
      d="M13.1181 4.02073C12.7819 3.24551 12.2972 2.54362 11.6914 1.95466C11.0835 1.36037 10.3669 0.88869 9.58064 0.565371C8.76278 0.226086 7.89492 0.054657 7.00028 0.054657C6.10564 0.054657 5.23778 0.226086 4.41992 0.563586C3.62885 0.890371 2.91992 1.35823 2.30921 1.95287C1.70371 2.54217 1.21906 3.24398 0.882422 4.01894C0.534207 4.82251 0.357422 5.67608 0.357422 6.55466C0.357422 7.81537 0.659208 9.07073 1.25206 10.2814C1.72885 11.2547 2.39492 12.2029 3.23421 13.1047C4.66814 14.6439 6.17171 15.585 6.59849 15.8368C6.71964 15.9083 6.8578 15.946 6.99849 15.9457C7.13778 15.9457 7.27528 15.91 7.39849 15.8368C7.82528 15.585 9.32885 14.6439 10.7628 13.1047C11.6021 12.2047 12.2681 11.2547 12.7449 10.2814C13.3414 9.07251 13.6431 7.81894 13.6431 6.55644C13.6431 5.67787 13.4664 4.8243 13.1181 4.02073ZM7.00028 14.5761C5.82349 13.8279 1.64314 10.8654 1.64314 6.55644C1.64314 5.16537 2.19849 3.85823 3.20742 2.87251C4.21992 1.88501 5.56635 1.34037 7.00028 1.34037C8.43421 1.34037 9.78064 1.88501 10.7931 2.8743C11.8021 3.85823 12.3574 5.16537 12.3574 6.55644C12.3574 10.8654 8.17706 13.8279 7.00028 14.5761ZM7.00028 3.55466C5.26456 3.55466 3.85742 4.9618 3.85742 6.69751C3.85742 8.43323 5.26456 9.84037 7.00028 9.84037C8.73599 9.84037 10.1431 8.43323 10.1431 6.69751C10.1431 4.9618 8.73599 3.55466 7.00028 3.55466ZM8.41457 8.1118C8.22907 8.29783 8.00862 8.44535 7.7659 8.54587C7.52319 8.64639 7.26299 8.69792 7.00028 8.69751C6.46635 8.69751 5.96456 8.48859 5.58599 8.1118C5.39996 7.9263 5.25245 7.70585 5.15193 7.46314C5.05141 7.22042 4.99987 6.96022 5.00028 6.69751C5.00028 6.16359 5.20921 5.6618 5.58599 5.28323C5.96456 4.90466 6.46635 4.69751 7.00028 4.69751C7.53421 4.69751 8.03599 4.90466 8.41457 5.28323C8.79314 5.6618 9.00028 6.16359 9.00028 6.69751C9.00028 7.23144 8.79314 7.73323 8.41457 8.1118Z"
      fill="white"
    />
  </svg>
);

LocationFilled.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

LocationFilled.defaultProps = {
  width: 14,
  height: 16,
};

export default LocationFilled;
